import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SidebarComponent} from "./sidebar.component";
import {EntityManagerModule} from "../entity-manager/entity-manager.module";
import { FileUploadModule } from '../file-upload/file-upload.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [
    SidebarComponent,
  ],
  imports: [
    CommonModule,
    EntityManagerModule,
    MatDialogModule,
    MatButtonModule,
    FileUploadModule,
  ],
  exports: [
    SidebarComponent,
  ]
})
export class SidebarModule { }
